export const elementsValues = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
];

export const typesOfProducts = ["Ledger", "Marker", "Bevel", "Slant", "Die", "Base", "Vase", "Others"];

export const includeItems = ["Porcelain"];

export const vasDefaultTypesAndIncludes = {
  types: {
    Ledger: false,
    Marker: false,
    Bevel: false,
    Slant: false,
    Die: false,
    Base: false,
    Vase: false,
    Others: false,
  },
  includes: {
    Porcelain: false,
  },
};

export const initVasData = {
  services: {
    sandBlasting: false,
    etching: false,
  },
};

export const clearData = {
  services: {
    sandBlasting: false,
    etching: false,
  },
  types: {
    Ledger: false,
    Marker: false,
    Bevel: false,
    Slant: false,
    Die: false,
    Base: false,
    Vase: false,
    Others: false,
  },
  includes: {
    Porcelain: false,
  },
};

export default elementsValues;
